import * as React from 'react';
import './reservationNote.module.scss';

export const PRIVACY_POLICY_URL = 'https://she-inc.jp/common/policy.html';
export const SHEID_AGREEMENT_URL = 'https://she-inc.co.jp/common/agreement.html?agreement_type=sheid';

export const ReservationNote = () => (
  <div styleName="reservation-note" id="reservation-note">
    ※
    <a styleName="link" href={PRIVACY_POLICY_URL} target="_blank" id="privacy-policy-link">
      プライバシーポリシー
    </a>
    と
    <a styleName="link" href={SHEID_AGREEMENT_URL} target="_blank" id="sheid-agreement-link">
      SHEID利用規約
    </a>
    にご同意頂けた場合のみ、申込ボタンをクリックしてください。
    <br />
    <br />
    ※無断キャンセルの場合、キャンセル料として1,000円を頂戴致します。またその場合、今後一切の特典適用が出来かねますので、ご認識のほどよろしくお願いいたします。
  </div>
);
